import React, { useState } from "react";
import { db, storage } from "../../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

function StudentForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    investment: "",
    city: "",
  });


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Upload file and return URL
  const uploadFile = async (file, folder) => {
    const fileRef = ref(
      storage,
      `${folder}/${Date.now()}_${file.name}`
    );
    await uploadBytes(fileRef, file);
    return await getDownloadURL(fileRef);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

   

    try {


      await addDoc(collection(db, "franchisee_new_data"), {
        ...formData,
     
        createdAt: serverTimestamp(),
        createdAtDate: new Date(),
      });

      alert("Application submitted successfully!");

      setFormData({
        name: "",
        email: "",
        mobile: "",
        investment: "",
        city: "",
      });
    
    } catch (error) {
      console.error(error);
      alert("Submission failed");
    }
  };

  return (
    <div className="card p-3">
      <h3 className="text-center text-primary">
        <b>Apply Franchisee</b>
      </h3>

      <form onSubmit={handleSubmit}>
        <div className="row">

          <div className="col-md-6 mt-2">
            <input
              type="text"
              name="name"
              className="form-control"
              placeholder="Enter Name*"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-6 mt-2">
            <input
              type="text"
              name="email"
              className="form-control"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              
            />
          </div>

          <div className="col-md-6 mt-2">
            <input
              type="tel"
              name="mobile"
              className="form-control"
              placeholder="Mobile Number*"
              pattern="[0-9]{10}"
              maxLength="10"
              value={formData.mobile}
              onChange={handleChange}
              required
            />
          </div>
             <div className="col-md-6 mt-0">
            <input
              type="text"
              name="city"
              className="form-control"
              placeholder="City"
           
              value={formData.city}
              onChange={handleChange}
              required
            />
          </div>
   <div className="col-md-6 mt-2">
            <input
              type="text"
              name="investment"
              className="form-control"
              placeholder="Investment*"
         
              value={formData.investment}
              onChange={handleChange}
              required
            />
          </div>




      

        </div>

        <center>
          <button className="btn btn-primary mt-3" type="submit">
            Submit Application
          </button>
        </center>
      </form>
    </div>
  );
}

export default StudentForm;
